import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Description',
    isTitle: true,
    field: 'description',
    component: inputTextField({ req: true })
  })
].concat(defaultColumns)
